import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';
import { useAnalytics } from '@/services/analytics';
import { useMountEffect } from '@/hooks/state/use-mount-effect';
import { AssistantFooter } from './assistant-footer';
import { AgentFooterBar } from './agent-footer-bar';

/**
 * Flag switch for the agent entry point: the agent footer bar (with chips for
 * recent conversations) or today's "Ask agent" footer.
 */
export function AgentLauncher() {
  const isFooterBarEnabled = useFeatureFlag(AccountFeatureFlag.AgentFloatingLauncher);
  const { track } = useAnalytics();

  // Exposure tracking for the agent_floating_launcher rollout: which arm this
  // load was served, whether or not the user ever opens the agent.
  useMountEffect(() => {
    void track('aiAssistant', 'launcherDisplayed', {
      Variant: isFooterBarEnabled ? 'bar' : 'footer',
    });
  });

  return isFooterBarEnabled ? <AgentFooterBar /> : <AssistantFooter />;
}
